import party from './party.js'
import prePaidGratuities from './prePaidGratuities.js'
import transfers from './transfers.js'
import flights from './flights.js'
import travelProtection from './travelProtection.js'
import extraDays from './extraDays.js'
import * as tabChange from './tabChange.js'

export default [
  party,
  prePaidGratuities,
  transfers,
  flights,
  travelProtection,
  extraDays,
  tabChange,
]